function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);} /* eslint-disable max-statements */
/* eslint-disable max-lines */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Translate, t } from "../../I18N";

import { useForm } from 'react-hook-form';
import { actions } from "../../BasicReducer";
import { notificationActions } from "../../Notifications";
import { ToggleButton } from "../../UI";
import { MultiSelect, Geolocation } from "../../Forms";
import { RequestParams } from "../../utils/RequestParams";
import SettingsAPI from "../SettingsAPI";
import { FeatureToggle } from "../../components/Elements/FeatureToggle";
import { validateHomePageRoute } from "../../utils/routeHelpers";
import { ToggleChildren } from "./ToggleChildren";
import * as tips from "./collectionSettingsTips";
import { SettingsFormElement } from "./SettingsFormElement";
import { SettingsHeader } from "./SettingsHeader";

const mapStateToProps = ({ settings, templates }) => ({
  collectionSettings: settings.collection,
  templates
});

const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  {
    setSettings: actions.set.bind(null, 'settings/collection'),
    notify: notificationActions.notify
  },
  dispatch
);

const connector = connect(mapStateToProps, mapDispatchToProps);



const CollectionSettings = ({
  collectionSettings,
  templates,
  setSettings,
  notify
}) => {
  const collectionSettingsObject = collectionSettings.toJS();
  const templatesObject = templates.toJS();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors }
  } = useForm({
    // @ts-ignore
    defaultValues: collectionSettingsObject,
    mode: 'onSubmit'
  });

  const save = async (newCollectionSettings) => {var _newCollectionSetting;
    const saveParameters = new RequestParams(_objectSpread(_objectSpread(_objectSpread({},
    collectionSettingsObject),
    newCollectionSettings), {}, {
      mapApiKey: (_newCollectionSetting = newCollectionSettings.mapApiKey) === null || _newCollectionSetting === void 0 ? void 0 : _newCollectionSetting.replace(/\s+/g, ' ').trim() })
    );
    const result = await SettingsAPI.save(saveParameters);
    setSettings(result);
    notify(t('System', 'Settings updated', null, false), 'success');
  };
  const year = t('System', 'Year', null, false);
  const month = t('System', 'Month', null, false);
  const day = t('System', 'Day', null, false);

  return /*#__PURE__*/(
    _jsx("div", { className: "settings-content" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "panel panel-default collection-settings" }, void 0, /*#__PURE__*/
    _jsx("form", { id: "collectionSettings", className: "", onSubmit: handleSubmit(save) }, void 0, /*#__PURE__*/
    _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Collection")
    ), /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "General")
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Collection name" }, void 0, /*#__PURE__*/
    React.createElement("input", _extends({ type: "text" }, register('site_name'), { className: "form-control" }))
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Custom favicon", tip: tips.customFavIcon }, void 0, /*#__PURE__*/
    _jsx(ToggleChildren, {
      toggled: Boolean(watch('favicon')),
      onToggleOff: () => {
        setValue('favicon', '');
      } }, void 0, /*#__PURE__*/

    React.createElement("input", _extends({ type: "text" }, register('favicon'), { className: "form-control" }))
    )
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Use custom landing page", tip: tips.landingPageTip }, void 0, /*#__PURE__*/
    _jsx(ToggleChildren, {
      toggled: Boolean(watch('home_page')),
      onToggleOff: () => {
        setValue('home_page', '');
      } }, void 0, /*#__PURE__*/

    _jsx("div", { className: `input-group ${errors.home_page ? 'has-error' : ''}` }, void 0, /*#__PURE__*/
    _jsx("span", { className: "input-group-addon", id: "basic-addon1" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "https://yourdomain")
    ), /*#__PURE__*/
    React.createElement("input", _extends({
      type: "text",
      className: "form-control" },
    register('home_page', {
      validate: (val) =>
      validateHomePageRoute(val) || val === ''
    }))
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "has-error" }, void 0,
    errors.home_page && /*#__PURE__*/
    _jsx("div", { className: "error-message" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Invalid home page url")
    )

    )
    )
    ), /*#__PURE__*/
    _jsx(SettingsFormElement, { label: "Default view" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "col-xs-12 col-lg-3 col-no-gutters" }, void 0, /*#__PURE__*/
    React.createElement("select", _extends({ className: "form-control" }, register('defaultLibraryView')), /*#__PURE__*/
    _jsx("option", { value: "cards" }, void 0, t('System', 'Cards', null, false)), /*#__PURE__*/
    _jsx("option", { value: "table" }, void 0, t('System', 'Table', null, false)), /*#__PURE__*/
    _jsx("option", { value: "map" }, void 0, t('System', 'Map', null, false))
    )
    )
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Date format" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "col-xs-12 col-lg-3 col-no-gutters" }, void 0, /*#__PURE__*/
    React.createElement("select", _extends({ className: "form-control" }, register('dateFormat')), /*#__PURE__*/
    _jsx("option", { value: "yyyy/MM/dd" }, void 0, "2021/02/26 (",
    year, ", ", month, ", ", day, ")"
    ), /*#__PURE__*/
    _jsx("option", { value: "dd/MM/yyyy" }, void 0, "26/02/2021 (",
    day, ", ", month, ", ", year, ")"
    ), /*#__PURE__*/
    _jsx("option", { value: "MM/dd/yyyy" }, void 0, "02/26/2021 (",
    month, ", ", day, ", ", year, ")"
    ), /*#__PURE__*/
    _jsx("option", { value: "yyyy-MM-dd" }, void 0, "2021-02-26 (",
    year, ", ", month, ", ", day, ")"
    ), /*#__PURE__*/
    _jsx("option", { value: "dd-MM-yyyy" }, void 0, "26-02-2021 (",
    day, ", ", month, ", ", year, ")"
    ), /*#__PURE__*/
    _jsx("option", { value: "MM-dd-yyyy" }, void 0, "02-26-2021 (",
    month, ", ", day, ", ", year, ")"
    )
    )
    )
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Private instance", tip: tips.publicSharing }, void 0, /*#__PURE__*/
    _jsx(ToggleButton, {
      checked: Boolean(watch('private')),
      onClick: () => {
        setValue('private', !getValues('private'));
      } }
    )
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Show cookie policy", tip: tips.cookiePolicy }, void 0, /*#__PURE__*/
    _jsx(ToggleButton, {
      checked: Boolean(watch('cookiepolicy')),
      onClick: () => {
        setValue('cookiepolicy', !getValues('cookiepolicy'));
      } }
    )
    ),

    !collectionSettingsObject.newNameGeneration && /*#__PURE__*/
    _jsx(SettingsFormElement, { label: "Non-latin characters support", tip: tips.characterSupport }, void 0, /*#__PURE__*/
    _jsx(ToggleButton, {
      checked: Boolean(watch('newNameGeneration')),
      onClick: () => {
        setValue('newNameGeneration', getValues('newNameGeneration'));
      } }
    )
    ), /*#__PURE__*/


    _jsx(SettingsFormElement, { label: "Global JS", tip: tips.globalJS }, void 0, /*#__PURE__*/
    _jsx(ToggleButton, {
      checked: Boolean(watch('allowcustomJS')),
      onClick: () => {
        setValue('allowcustomJS', !getValues('allowcustomJS'));
      } }
    )
    ), /*#__PURE__*/

    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Website analytics")
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Google Analytics", tip: tips.analytics }, void 0, /*#__PURE__*/
    _jsx(ToggleChildren, {
      toggled: Boolean(watch('analyticsTrackingId')),
      onToggleOff: () => {
        setValue('analyticsTrackingId', '');
      } }, void 0, /*#__PURE__*/

    React.createElement("input", _extends({ type: "text" }, register('analyticsTrackingId'), { className: "form-control" }))
    )
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Matomo Analytics", tip: tips.analytics }, void 0, /*#__PURE__*/
    _jsx(ToggleChildren, {
      toggled: Boolean(watch('matomoConfig')),
      onToggleOff: () => {
        setValue('matomoConfig', '');
      } }, void 0, /*#__PURE__*/

    React.createElement("input", _extends({ type: "text" }, register('matomoConfig'), { className: "form-control" }))
    )
    ), /*#__PURE__*/

    _jsx(FeatureToggle, { feature: "ocr.url" }, void 0, /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Services")
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Document OCR trigger", tip: tips.ocrTrigger }, void 0, /*#__PURE__*/
    _jsx(ToggleButton, {
      checked: Boolean(watch('ocrServiceEnabled')),
      onClick: () => {
        setValue('ocrServiceEnabled', !getValues('ocrServiceEnabled'));
      } }
    )
    )
    ), /*#__PURE__*/

    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Forms and email configuration")
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Contact Form", tip: tips.emails[0] }, void 0, /*#__PURE__*/
    _jsx(ToggleChildren, {
      toggled: Boolean(watch('contactEmail') || watch('senderEmail')),
      onToggleOff: () => {
        setValue('contactEmail', '');
        setValue('senderEmail', '');
      } }, void 0, /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Receiving email", tip: tips.receivingEmail }, void 0, /*#__PURE__*/
    React.createElement("input", _extends({ type: "text" }, register('contactEmail'), { className: "form-control" }))
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Sending email", tip: tips.emails[1] }, void 0, /*#__PURE__*/
    React.createElement("input", _extends({
      type: "text" },
    register('senderEmail'), {
      placeholder: "no-reply@uwazi.io",
      className: "form-control" })
    )
    )
    )
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Public Endpoints", tip: tips.publicForm[0] }, void 0, /*#__PURE__*/
    _jsx(ToggleChildren, {
      toggled: Boolean(
        (watch('allowedPublicTemplates') || []).length || watch('publicFormDestination')
      ),
      onToggleOff: () => {
        setValue('publicFormDestination', '');
        setValue('allowedPublicTemplates', []);
      } }, void 0, /*#__PURE__*/

    _jsx("div", { className: `${errors.publicFormDestination ? 'has-error' : ''}` }, void 0, /*#__PURE__*/
    _jsx(SettingsFormElement, {
      label: "Public Form submit URL",
      tip: tips.publicForm[1],
      labelClassName: "larger-label",
      inputsClassName: "smaller-inputs" }, void 0, /*#__PURE__*/

    React.createElement("input", _extends({
      placeholder: "https://example.io" },
    register('publicFormDestination', { pattern: /^https?:\/\/.+$/ }), {
      className: "form-control" })
    )
    )
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, {
      label: "Whitelisted Templates",
      tip: tips.publicForm[2],
      labelClassName: "larger-label",
      inputsClassName: "smaller-inputs" }, void 0, /*#__PURE__*/

    _jsx(MultiSelect, {
      value: watch('allowedPublicTemplates'),
      options: templatesObject.map((template) => ({
        label: template.name,
        value: template._id
      })),
      onChange: (newValues) => {
        setValue('allowedPublicTemplates', newValues);
      } }
    )
    )
    )
    ), /*#__PURE__*/

    _jsx(SettingsFormElement, { label: "Allow captcha bypass", tip: tips.openPublicForm }, void 0, /*#__PURE__*/
    _jsx(ToggleButton, {
      checked: Boolean(watch('openPublicEndpoint')),
      onClick: () => {
        setValue('openPublicEndpoint', !getValues('openPublicEndpoint'));
      } }
    )
    ), /*#__PURE__*/

    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Maps")
    ), /*#__PURE__*/
    _jsx(SettingsFormElement, { label: "Map provider" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "col-xs-12 col-lg-3 col-no-gutters" }, void 0, /*#__PURE__*/
    React.createElement("select", _extends({ className: "form-control" }, register('tilesProvider')), /*#__PURE__*/
    _jsx("option", { value: "mapbox" }, void 0, t('System', 'MapBox', null, false)), /*#__PURE__*/
    _jsx("option", { value: "google" }, void 0, t('System', 'Google Maps', null, false))
    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: `${errors.mapApiKey ? 'has-error' : ''}` }, void 0, /*#__PURE__*/
    _jsx(SettingsFormElement, { label: "Map api key", tip: tips.mapApiKey }, void 0, /*#__PURE__*/
    React.createElement("input", _extends({
      type: "text" },
    register('mapApiKey', { pattern: /^[a-zA-Z0-9._]+$/ }), {
      className: "form-control" })
    )
    )
    ), /*#__PURE__*/
    _jsx(SettingsFormElement, { label: "Custom starting location", tip: tips.mapAxis }, void 0, /*#__PURE__*/
    _jsx("div", { className: "settings-map" }, void 0, /*#__PURE__*/
    _jsx(Geolocation, {
      value: watch('mapStartingPoint'),
      onChange: (values) => {
        setValue('mapStartingPoint', values);
      } }
    )
    )
    )
    ), /*#__PURE__*/

    _jsx("div", { className: "settings-footer" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "submit",
      form: "collectionSettings",
      className: "btn btn-success btn-extra-padding" }, void 0, /*#__PURE__*/

    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )
    )
    )
    ));

};

const container = connector(CollectionSettings);
export { container as CollectionSettings };